import * as React from "react";
import { css } from "@emotion/css";
import { DebugNavigationButton } from "./DebugNavigationButton";

const DebugNavigation = () => {
  const debugNavigationWrapper = css`
    position: fixed;
    right: 15px;
    bottom: 75px;
    padding: 15px;
    background: rgba(0, 0, 0, 0.1);
    text-align: left;
    border-radius: 5px;
    ul {
      margin: 0;
      padding: 0;
      li {
        list-style-type: none;
      }
    }
  `;

  return (
    <div className={debugNavigationWrapper}>
      <ul>
        <DebugNavigationButton url="/" displayText="Current Firm" />
        <DebugNavigationButton
          url="/transferDetails"
          displayText="Transfer Details"
        />
        <DebugNavigationButton
          url="/transferInstructions"
          displayText="Transfer Instructions"
        />
        <DebugNavigationButton
          url="/personalInformation"
          displayText="Personal Information"
        />
        <DebugNavigationButton
          url="/fundSelection"
          displayText="Fund Selection"
        />
        <DebugNavigationButton url="/review" displayText="Review" />
        <DebugNavigationButton url="/sign" displayText="Sign" />
      </ul>
    </div>
  );
};

export default DebugNavigation;
